module.exports = __webpack_public_path__ + "img/bc4a742.jpg";